var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 15.3343H2.66683C1.9335 15.3343 1.3335 14.7343 1.3335 14.001C1.3335 13.2677 1.9335 12.6677 2.66683 12.6677H13.3335C14.0668 12.6677 14.6668 13.2677 14.6668 14.001C14.6668 14.7343 14.0668 15.3343 13.3335 15.3343ZM8.70683 2.79435L11.2068 5.29435L5.36016 11.141C5.24016 11.2677 5.06683 11.3343 4.8935 11.3343H3.3335C2.96683 11.3343 2.66683 11.0343 2.66683 10.6677V9.10768C2.66683 8.92768 2.74016 8.76101 2.86016 8.63435L8.70683 2.79435ZM11.9202 4.58102L9.42016 2.08102L10.6402 0.861016C10.9002 0.601016 11.3202 0.601016 11.5802 0.861016L13.1402 2.42102C13.4002 2.68102 13.4002 3.10102 13.1402 3.36102L11.9202 4.58102Z",
    fill: "url(#paint0_linear_127_3586)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_127_3586",
    x1: 1.3335,
    y1: 0.666016,
    x2: 5.29135,
    y2: 17.5342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416667,
    stopColor: "#091A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#234157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#387484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A182"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.7c52a5f36cd9c296c83e28ca3a2568f9.svg";
export { ForwardRef as ReactComponent };